import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Toolbar,
  Box
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import ImageIcon from '@mui/icons-material/Image';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ReviewIcon from '@mui/icons-material/RateReview';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SearchIcon from '@mui/icons-material/Search';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import FindReplaceIcon from '@mui/icons-material/FindReplace';

const drawerWidth = 240;

const Sidebar = ({ open }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const menuItems = [
    {
      text: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard',
    },
    {
      text: 'Generate Images',
      icon: <ImageIcon />,
      path: '/generate-mrhi',
    },
    {
      text: 'Review & Submit',
      icon: <ReviewIcon />,
      path: '/manage-images',
    },
    {
      text: 'Report & Search',
      icon: <SearchIcon />,
      path: '/search',
    },
    {
      text: 'Scheduled Submissions',
      icon: <ScheduleIcon />,
      path: '/scheduled-submissions',
    },
    {
      text: 'UPC Migration',
      icon: <SwapHorizIcon />,
      path: '/upc-migration',
    },
    {
      text: 'Carousel Batch',
      icon: <ViewCarouselIcon />,
      path: '/carousel-batch',
    },
    {
      text: 'Marketing Copy',
      icon: <FindReplaceIcon />,
      path: '/marketing-copy',
    },
  ];
  
  // Add admin menu items if user is admin
  if (user && user.is_admin) {
    menuItems.push(
      { divider: true },
      {
        text: 'Admin Panel',
        icon: <AdminPanelSettingsIcon />,
        path: '/admin',
      }
    );
  }

  return (
    <Drawer
      variant="persistent"
      open={open}
      sx={{
        width: open ? drawerWidth : 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
    >
      <Toolbar /> {/* Spacer to push content below AppBar */}
      <Box sx={{ overflow: 'auto' }}>
        <List>
          {menuItems.map((item, index) => (
            item.divider ? (
              <Divider key={`divider-${index}`} />
            ) : (
              <ListItem 
                button 
                key={item.text}
                onClick={() => navigate(item.path)}
                selected={location.pathname === item.path}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            )
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;